import { Component, OnInit, OnDestroy, NgZone } from '@angular/core';
import { VideoChatMessage } from '../../../model/video-chat/video-chat-message';
import { MessageServerService } from '../../../services/hub-services/message-server/message-server.service';
import { AuthService } from '../../../services/auth.service';
import { NotificationToastService, NotificationToastResponse } from 'src/app/services/notification-toast.service';
import { MedicalServiceService } from 'src/app/services/medical-service.service';
import { MedicalServiceWizardService } from '../../../services/wizard/medical-service/medical-service-wizard'; 
import { Router } from '@angular/router';
import { VideoChatAlertService } from '../../../services/video-chat/video-chat-alert.service';

@Component({
  selector: 'app-video-chat-alert',
  templateUrl: './video-chat-alert.component.html',
  styleUrls: ['./video-chat-alert.component.css']
})
export class VideoChatAlertComponent implements OnInit, OnDestroy {

  videoChatRequesReceivedSubscription: any;
  notificationToastResponse: NotificationToastResponse;
  inVideoChat: boolean;

  constructor( private messageServerService: MessageServerService,
               private notificationToastService: NotificationToastService,
               private medicalServiceService: MedicalServiceService,
               private medicalServiceWizardService: MedicalServiceWizardService,
               private videoChatAlertService: VideoChatAlertService,
               private router: Router,
               private ngZone: NgZone,
               private authService: AuthService ) { }

  ngOnInit() {

    this.messageServerService.physicianReceived.subscribe( (message) => {

      if ( message ) {
        this.ngZone.run(() => {
          const videoChatMessage = <VideoChatMessage>JSON.parse(message);
          if ( this.authService.getPhysicianId() === videoChatMessage.PhysicianId ) {
            const mess = `El paciente ${ videoChatMessage.Patient } se encuentra en sala de espera virtual`;
            this.showMessage(mess, videoChatMessage.MedicalAppointmentId);
          }
        });
      }
    });
  }

  showMessage(mess: string, medicalAppointmentId: number) {

    if (this.notificationToastResponse) {
      this.notificationToastService.clear(this.notificationToastResponse.toastId);
    }
    this.notificationToastResponse = this.notificationToastService.info(mess, 'Video chat', true, true);
    this.notificationToastResponse.onTap.subscribe(async () => {
      const medicalServiceSearchItem = await this.medicalServiceService
        .getMedicalServiceSearchItemByMedicalAppointmentId(medicalAppointmentId);
      await this.medicalServiceService.medicalAppointmentCareStart(medicalServiceSearchItem);
      await this.medicalServiceWizardService.initialize(medicalServiceSearchItem);
      this.router.navigate(['/medical-service-wizard']);
    });
  }

  isInVideoChat(): boolean {
    return this.videoChatAlertService.isInVideoChat();
  }

  async startVideoChat() {
    this.videoChatAlertService.startVideoChat( );
  }

  ngOnDestroy(): void {
  }
}
